<template>
    <div class="login text-center" id="app"  @keyup.enter="submitForm('ruleForm')">
        <h2 class="color-white">{{ appName ? appName+'后台管理系统' : '后台管理系统' }}</h2>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm" style="max-width: 500px;margin:30px auto;">
            <el-form-item label="登录账号" prop="name"><el-input type="text" v-model="ruleForm.name" autocomplete="off" placeholder="请输入账号"></el-input></el-form-item>
            <el-form-item label="登录密码" prop="password"><el-input type="password" v-model="ruleForm.password" autocomplete="off" placeholder="请输入密码"></el-input></el-form-item>
            <!-- <el-form-item label="验证码" prop="verify">
                <el-input type="text" v-model="ruleForm.verify" autocomplete="off" style="width: 60%;"></el-input>
                <img src="http://192.168.1.66/home.index/code" style="width: 100px;height: 40px;" />
            </el-form-item> -->
            <el-form-item class="flex space-between">
                <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
        </el-form>
        <el-dialog :visible.sync="dialogVisible" width="30%" class="puzz">
            <div class="puzzle-box">
                <puzzle-verification
                    :onSuccess="handleSuccess"
                    :puzzleImgList="puzzleImgList"
                    :isVerificationShow="isVerificationShow"
                    ref="PuzzleVerification"
                    :width="screenWidth <= '768' ? screenWidth * 0.8 - 70 : '260'"
                />
            </div>
        </el-dialog>
        
    </div>
</template>

<script>
import { 
    mapState,
    mapMutations,
    mapActions 
} from 'vuex';
import PuzzleVerification from '../../plugins/verify.js';
export default {
    components: {
        PuzzleVerification
    },
    data() {
        var checkUser = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('账号不能为空'));
            } else {
                callback();
            }
        };
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else {
                if (this.ruleForm.checkPass !== '') {
                    this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
            }
        };
        // var checkVerify = (rule, value, callback) => {
        //     if (!value) {
        //         return callback(new Error('请输入验证码'));
        //     } else {
        //         callback();
        //     }
        // };
        return {
            screenWidth: document.body.clientWidth,
            ruleForm: {
                name: '',
                password: '',
                // verify: ''
            },
            rules: {
                password: [
                    {
                        validator: validatePass,
                        trigger: 'blur'
                    }
                ],
                name: [
                    {
                        validator: checkUser,
                        trigger: 'blur'
                    }
                ]
            },
            isVerificationShow: true,
            puzzleImgList: [
                require('../../assets/verifyImages/verify1.png'),
                require('../../assets/verifyImages/verify2.png'),
                require('../../assets/verifyImages/verify3.png'),
                require('../../assets/verifyImages/verify4.png'),
                require('../../assets/verifyImages/verify5.png'),
                require('../../assets/verifyImages/verify6.png'),
                require('../../assets/verifyImages/verify7.png'),
				require('../../assets/verifyImages/verify8.png')
            ],
            dialogVisible: false
        };
    },
    computed:{
        appName(){
            return this.$store.state.auth.appName
        }
    },
    mounted() {
        this.$axios({
            url: this.HOST + '/admin.login/settingInfo',
            method: 'post'
        })
            .then(res => {
                this.setAppName(res.data.systemName);
            })
            .catch(err => {});
    },
    methods: {
        ...mapActions({
            login: 'auth/login'
        }),
        ...mapMutations({
            setAppName: 'auth/setAppName'
        }),
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.dialogVisible = true;
                    this.isVerificationShow = false;
                    setTimeout(() => {
                        this.isVerificationShow = true;
                    }, 100);
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        reflesh() {
            this.$refs.PuzzleVerification.refreshImg();
        },
        onClose(e) {
            console.log(e);
        },
        handleSuccess() {
            this.dialogVisible = false;
            this.isVerificationShow = false;
            let url = this.HOST + '/admin.login/login';  
            let userInfo = this.ruleForm;
            this.login({
                url,
                userInfo
            }).then(res => {
                if(res.data.status == 1){
					sessionStorage.setItem('save_webimg',res.data.save_webimg);
					this.$router.push('home');
                }else{
                    this.$message.error(res.data.msg)
                }
            });
        }
    }
};
</script>

<style>
.login{
	padding-top: calc((100vh - 300px)/2);
	box-sizing: border-box;
	height: 100vh;
}
.el-form {
    margin-top: 30px;
    padding-right: 20px;
}
.login .el-form-item__label{
	color: #fff !important;
}
.puzzle-box {
    box-sizing: border-box;
}
.puzzle-container {
    box-sizing: border-box;
    width: 100%;
}

@media screen and (max-width: 768px) {
    #puzzle-box,
    .slider-container {
        width: 100% !important;
    }
    .el-dialog {
        width: 80% !important;
    }
}
.puzzle-container{
	display: block !important;
}
.puzzle-container>div{
	margin-left: auto;
	margin-right: auto;
}
</style>
